<template>
  <transition name="playlist">
    <div class="video-item playlist-video-item">
      <playlist-series-item
        v-if="item.type && item.type === 'series'"
        :item="item"
        v-on:add-to-playlist="$emit('add-to-playlist', item.id)"
      >
        {{ item.pagetitle }}
      </playlist-series-item>
      <div v-else>
        <div class="item-overlay">
          <a href="#" @click.prevent="$emit('add-to-playlist', item.id)">
            <div class="play-icon">
              <i :class="iconCls"></i>
            </div>
          </a>
        </div>

        <img :src="imgUrl" :alt="item.pagetitle" class="video-img" />

        <div class="video-info">
          <div>
            <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M12 20C16.4 20 20 16.4 20 12S16.4 4 12 4 4 7.6 4 12 7.6 20 12 20M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M17 13.9L16.3 15.2L11 12.3V7H12.5V11.4L17 13.9Z"
              />
            </svg>
            <span>{{ item.videoDuration }} דק’</span>
          </div>
          <div>
            <current-tag
              :current="getCurrent"
              :base="this.$store.state.initialData.basepath"
            >
            </current-tag>
          </div>
          <level-icon :level="level"></level-icon>
        </div>
        <div class="video-item-h4">
          <h4>{{ item.pagetitle }}</h4>
        </div>
        <div>
          <teacher-tag
            :teacher="getTeacher"
            :base="this.$store.state.initialData.basepath"
          >
          </teacher-tag>
        </div>
        <p class="description" v-html="abstract"></p>
        <div class="read-more">
          <svg style="width: 20px; height: 20px" viewBox="0 0 20 20">
            <path
              fill="currentColor"
              d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
            />
          </svg>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import TeacherTag from "@/components/TeacherTag_v2.vue";
import CurrentTag from "@/components/CurrentTag_v2.vue";
import LevelIcon from "@/components/levelIcon.vue";
import PlaylistSeriesItem from "@/components/playlists/playlistSeriesItem.vue";

export default {
  name: `VideoItem`,

  props: {
    item: Object,
  },
  components: {
    CurrentTag,
    TeacherTag,
    LevelIcon,
    PlaylistSeriesItem,
  },

  computed: {
    imgUrl() {
      return this.$store.state.initialData.basepath + this.item.ch;
    },
    getCurrent() {
      if (Array.isArray(this.$store.state.currents)) {
        const current = this.$store.state.currents.find(
          c =>
            typeof c.resource !== `undefined` &&
            c.resource.id === this.item.current
        );

        return current;
      }
      return { alias: "" };
    },
    getTeacher() {
      const teacher = this.$store.state.initialData.teachers.find(
        t => t.id === this.item.videoTeacher
      );
      if (teacher) {
        return teacher;
      }
      return { id: `` };
    },
    level() {
      if (this.$store.state.initialData.levels.length > 0) {
        const lvl = this.$store.state.initialData.levels.find(
          l => l.value === this.item.videoLvl
        );

        if (lvl) {
          return lvl;
        }
      }
      return { label: `` };
    },
    abstract() {
      const str = this.item.description;
      if (str.length > 150) {
        return `${str.slice(0, 150)}...`;
      }
      return str;
    },
    iconCls() {
      if (
        this.$store.state.user.currentPlaylist.videos.includes(
          `${this.item.id}`
        )
      ) {
        return "mdi mdi-check-circle is-selected";
      }
      return "mdi mdi-check-circle";
    },
  },
};
</script>

<style lang="scss">
.video-item.playlist-video-item {
  .play-icon {
    opacity: 0.7;
    .mdi {
      font-size: 3.5rem;
      color: #ffffff;
    }
    .mdi.is-selected {
      color: #e97575;
    }
  }
  .item-overlay {
    display: block;
    background-color: rgba($color: #c4c4c4, $alpha: 0.52);
    bottom: 0;
  }
}
</style>
